"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedDate = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const availability_tiles_1 = require("@kyruus/availability-tiles");
const types_1 = require("@kyruus/types");
const LocationAvailability_1 = require("../LocationAvailability");
const SelectedLocation_1 = require("./SelectedLocation");
const NoAvailabilityMessage_1 = require("../NoAvailabilityMessage");
const LocationDetails_1 = require("../LocationDetails");
const utils_1 = require("../../lib/utils");
const messages_1 = require("../../lib/messages");
const styles_1 = require("../styles");
const styles_2 = require("../../styles");
/**
 * The component that renders LocationAvailability when a user has selected a date.
 * Looks at all availability and suggests more dates if selected date has no availability.
 * Can be either:
 * - based on all locations
 * - or on 1 selected location
 */
exports.SelectedDate = (0, intl_1.injectIntl)(({ formatAvailability, availability, intl, locations = [], maxAvailabilitiesToDisplay, provider, selectedDate, selectedLocation, shouldRenderSlotsAsButtons, showRegulatedSpacesMessage, slotsStatus, tileSize, onTimeSlotsClick, viewMoreBookOnlineUrl, onViewMoreClick, log }) => {
    if (slotsStatus === types_1.PMCSlotStatuses.LOADING) {
        const locationToBeRender = selectedLocation
            ? [selectedLocation]
            : locations;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styles_2.DateHeading, null, (0, utils_1.formatDateForHeading)(selectedDate)),
            locationToBeRender.map((location) => (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(LocationDetails_1.LocationDetails, { location: location, selectedDate: selectedDate }),
                react_1.default.createElement(styles_1.SlotsLoadingAvailability, null,
                    react_1.default.createElement(availability_tiles_1.LoadingAvailabilityTiles, { compactHeight: 30, compactTiles: true, maxAvailabilitiesToDisplay: maxAvailabilitiesToDisplay, shouldDisplayAsOnMobile: true, tileSize: tileSize })))))));
    }
    if (selectedLocation) {
        return (
        /*
        UI for a selected location's availability
        is different from when all locations are displayed
        */
        react_1.default.createElement(SelectedLocation_1.SelectedLocation, { availability: availability, formatAvailability: formatAvailability, provider: provider, selectedDate: selectedDate, selectedLocation: selectedLocation, maxAvailabilitiesToDisplay: maxAvailabilitiesToDisplay, shouldRenderSlotsAsButtons: shouldRenderSlotsAsButtons, showRegulatedSpacesMessage: showRegulatedSpacesMessage, slotsStatus: slotsStatus, tileSize: tileSize, onTimeSlotsClick: onTimeSlotsClick, viewMoreBookOnlineUrl: viewMoreBookOnlineUrl, onViewMoreClick: onViewMoreClick, log: log }));
    }
    const allLocationsAvailabilityByDate = (0, utils_1.filterAvailabilityByLocationByDate)(availability, selectedDate);
    /*
    if at least 1 location has availability for the selected date
    render LocationAvailability for all locations
    */
    if ((0, utils_1.locationsHaveAvailability)(allLocationsAvailabilityByDate, locations)) {
        return (react_1.default.createElement(styles_1.LocationsContainer, { "data-testid": "Locations" },
            react_1.default.createElement(styles_2.DateHeading, null, (0, utils_1.formatDateForHeading)(selectedDate)),
            locations.map((location) => {
                const locationAvailability = allLocationsAvailabilityByDate[location.id];
                return (react_1.default.createElement(styles_1.LocationContainer, { key: location.id },
                    react_1.default.createElement(LocationAvailability_1.LocationAvailability, { formatAvailability: formatAvailability, locationAvailability: locationAvailability, maxAvailabilitiesToDisplay: maxAvailabilitiesToDisplay, provider: provider, providerLocation: location, shouldRenderSlotsAsButtons: shouldRenderSlotsAsButtons, showRegulatedSpacesMessage: showRegulatedSpacesMessage, slotsStatus: slotsStatus, selectedDate: selectedDate, tileSize: tileSize, onTimeSlotsClick: onTimeSlotsClick, viewMoreBookOnlineUrl: viewMoreBookOnlineUrl, onViewMoreClick: onViewMoreClick, log: log })));
            })));
    }
    /*
    if no locations have availability for the selected date
    filter the slots by the next available date
    and render LocationAvailability for all locations
    */
    const nextAvailableDate = (0, utils_1.getNextAvailableDate)({
        availability,
        selectedDate
    });
    const nextAvailableSlots = nextAvailableDate
        ? (0, utils_1.filterAvailabilityByLocationByDate)(availability, nextAvailableDate)
        : {};
    if ((0, utils_1.locationsHaveAvailability)(nextAvailableSlots, locations)) {
        return (react_1.default.createElement(styles_1.LocationsContainer, { "data-testid": "Locations" },
            react_1.default.createElement(NoAvailabilityMessage_1.NoAvailabilityMessage, { date: selectedDate }),
            react_1.default.createElement(styles_2.DateHeading, null, intl.formatMessage(messages_1.messages.nextAvailability, {
                date: (0, utils_1.formatDateForHeading)(nextAvailableDate)
            })),
            locations.map((location) => {
                const locationAvailability = nextAvailableSlots[location.id];
                return (react_1.default.createElement(styles_1.LocationContainer, { key: location.id },
                    react_1.default.createElement(LocationAvailability_1.LocationAvailability, { locationAvailability: locationAvailability, formatAvailability: formatAvailability, maxAvailabilitiesToDisplay: maxAvailabilitiesToDisplay, provider: provider, providerLocation: location, shouldRenderSlotsAsButtons: shouldRenderSlotsAsButtons, showRegulatedSpacesMessage: showRegulatedSpacesMessage, slotsStatus: slotsStatus, selectedDate: selectedDate, tileSize: tileSize, onTimeSlotsClick: onTimeSlotsClick, viewMoreBookOnlineUrl: viewMoreBookOnlineUrl, onViewMoreClick: onViewMoreClick, log: log })));
            })));
    }
    // If no locations have availability for any date render nothing
    return null;
});
//# sourceMappingURL=SelectedDate.js.map